import { EditorState, ContentState, convertToRaw, convertFromHTML, Modifier } from "draft-js";
import { useRef, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { S3FileUpload, S3FileUploadPost } from "../../api/fileUpload";
import { staticImg } from "../../siteData/users";
import icon_plus_white from "../../assets/images/icon_plus_white.svg";
import true_icon from "../../assets/images/true_icon.svg";
import icone_upload from "../../assets/images/icone_upload.svg";
import icone_download1 from "../../assets/images/icon_download1.svg";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Progress, Upload } from "antd";
import PopComponent from "../../pages/popContent";
import CustomModal from "../../hoc/CustomModal";
import { postActivity } from "../../api/courses";
import { ContextState } from "../../layout";
import { useContext } from "react";

// const CustomOption = (props) => {
//     const [error, setError] = useState({});
//     const { contextReducer } = useContext(ContextState);
//     const [modalName, setModalName] = useState("UserInfo");
//     let Modal = PopComponent[modalName];
//     const [openModal, setModalOpen] = useState(false);

//     const handleOpenModal = (type, data) => {
//         let flag = 0;
//         switch (type) {
//             case 'ErrorPop': {
//                 setModalName(type);
//                 setError(data)
//                 setModalOpen(!openModal);
//                 break;
//             }
//             default: {
//                 setModalName(type);
//                 setModalOpen(!openModal);
//                 break;
//             }
//         }
//         if (flag === 1) {
//             setModalName(type);
//             setModalOpen(!openModal);
//         }
//     };

//     const addStar = (e) => {
//         const { editorState, onChange } = props;
//         const config = {
//             headers: { "content-type": "multipart/form-data" },
//             onUploadProgress: event => {
//                 const percent = Math.floor((event.loaded / event.total) * 100);
//                 if (percent === 100) {
//                 }
//             }
//         };
//         const fileData = new FormData();
//         fileData.append('file', e.target.files[0]);
//         (contextReducer.cms_type === 'dl-program' ? S3FileUpload(fileData, config): S3FileUploadPost(fileData, config)).then(res => {
//             if (res.data.status === 200) {
//                 const blocksFromHtml =contextReducer.cms_type === 'dl-program' ? htmlToDraft(
//                     `${draftToHtml(
//                         convertToRaw(editorState.getCurrentContent())
//                     )}<a href='${res.data?.url}' target="_blank">${e.target.files[0]?.name}</a>`
//                 ) : htmlToDraft(
//                     `${draftToHtml(
//                         convertToRaw(editorState.getCurrentContent())
//                     )}<a href='https://discourse.online.usc.edu${res.data?.data?.short_path}'>${e.target.files[0]?.name}</a>`
//                 );
//                 const { contentBlocks, entityMap } = blocksFromHtml;

//                 const editorState2 = EditorState.createWithContent(
//                     ContentState.createFromBlockArray(contentBlocks, entityMap)
//                 ).getCurrentContent();

//                 onChange(EditorState.push(editorState, editorState2, 'insert-characters'));
//                 e.target.value = '';
//             } else if (res.data.status === 103) {
//                 handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
//             } else {
//                 handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
//             }
//         }).catch(err => {
//             handleOpenModal('ErrorPop', { header: "Error", body: err.message })
//         });
//     };

//     return (
//         <>
//             <div class="rdw-image-wrapper" title="File Upload" aria-expanded="false">
//                 <div class="rdw-option-wrapper" >
//                     <label for="file" style={{ marginBottom: 0, width: 'auto' }}>
//                         <i className="cursor_pointer"><img src={icone_upload} alt="upload icon" height="24" /></i>
//                         <input type="file" id="file" onChange={addStar} style={{ display: 'none' }} name="image" accept=".pdf" />
//                     </label>
//                 </div>
//             </div>
//             {
//                 Modal && (
//                     <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
//                         <Modal
//                             error={error}
//                             handleOpenModal={handleOpenModal}
//                         />
//                     </CustomModal>
//                 )
//             }
//         </>
//     );
// }


const CustomOption = (props) => {
    const [error, setError] = useState({});
    const { contextReducer } = useContext(ContextState);
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const addStar = (file) => {
        const { editorState, onChange } = props;
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            if (percent === 100) {
            }
          }
        };
        const fileData = new FormData();
        fileData.append('file', file);
    
        // Choose the appropriate upload function based on contextReducer.cms_type
    
        const uploadFunction =  ["dl-program","pre-college","certificates"]?.includes(contextReducer?.cms_type) ? S3FileUpload : S3FileUploadPost;
    
        // Perform the file upload
        uploadFunction(fileData, config)
          .then(res => {
            if (res.data.status === 200) {
              const url =  ["dl-program", "pre-college","certificates"]?.includes(contextReducer?.cms_type)? res.data?.url : `https://discourse.online.usc.edu${res.data?.data?.short_path}`;
              const blocksFromHtml = htmlToDraft(
                `${draftToHtml(convertToRaw(editorState.getCurrentContent()))}<a href='${url}' target="_blank">${file.name}</a>`
              );
              const { contentBlocks, entityMap } = blocksFromHtml;
              const newContentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
              onChange(newEditorState);
            } else if (res.data.status === 103) {
              handleOpenModal('ErrorPop', { header: "Info", body: res.data.message });
            } else {
              handleOpenModal('ErrorPop', { header: "Error", body: res.data.message });
            }
          })
          .catch(err => {
            handleOpenModal('ErrorPop', { header: "Error", body: err.message });
          });
      };

    const uploadProps = {
        showUploadList: false,
        beforeUpload: (file) => {
          addStar(file); 
          return false;
        },
        accept: '.pdf'
      };

    return (
        <>
            <Upload {...uploadProps}>
                <div className="rdw-image-wrapper" title="File Upload">
                    <div className="rdw-option-wrapper">
                    <label htmlFor="file" style={{ marginBottom: 0, width: "auto" }}>
                        <i className="cursor-pointer">
                        <img src={icone_upload} alt="upload icon" height="24" />
                        </i>
                    </label>
                    </div>
                </div>
            </Upload>
            {
                Modal && (
                    <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={error}
                            handleOpenModal={handleOpenModal}
                        />
                    </CustomModal>
                )
            }
        </>
    );
}

const CustomTextEditor = ({ id,type, value, label, course_id,noLimit=false, post_id,isLableRight, placeholder, handleError, uploadLabel,isHiddenOpt=false, customClass, uploadValue, errors, progress, name, handleChange, topic_id, _id, loading, ...rest }) => {
    const [error, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    const { contextReducer } = useContext(ContextState);
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const formData = useSelector(state => state.courseCrud);
    const eventData = useSelector(state => state.eventsCrud);
    const blocksFromHtml = htmlToDraft(value || '');
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));
    const uploadList = useRef(null);
    const editorRef = useRef();
    const [paste, setPaste] = useState(false);

    useEffect(() => {
        setEditorState(EditorState.createWithContent(contentState))
    }, [formData._id, eventData._id, topic_id, loading, formData.outline?.[+topic_id]?.sub_topic?.length])

    const handleUpload = (file) => {
        if (!file.type.match(/png|jpeg|jpg/g)) {
            handleOpenModal('ErrorPop', { header: "Info", body: 'Please add only png, jpg or jpeg files' })
        }
    };

    const handleBeforeInput = (chars) => {
        let targetValue = editorState?.getCurrentContent()?.getPlainText()?.trimEnd()
        const wordCount = targetValue.trim().split(/\s+/).length
        const isMax = wordCount > 500 ? false : true;
        if(!noLimit){
            if ((editorState?.getCurrentContent()?.getPlainText().length >= 1500 && label !== 'Activity' && name !== 'raw' && !isHiddenOpt) || (!isMax && isHiddenOpt)) {
                return 'handled';
            }
        }
    };

    // -----------------------------------------------------------==============================-----------------------------------------------------------------------//

    const onEditorStateChange = (editorState) => {
        const contentState = editorState.getCurrentContent();
        let targetValue = editorState?.getCurrentContent()?.getPlainText()
        const wordCount = targetValue.trim().split(/\s+/).length
        const isMax = wordCount > 500 ? false : true;
        if (contentState.getPlainText().length >= 1500 && label !== 'Activity' && name !== 'raw' && !isHiddenOpt && !noLimit) {
            setPaste(true)
        }else if(!isMax && isHiddenOpt && !noLimit){
            setPaste(true)
        }
        else {
            setPaste(false)
        }
        if (contentState.getPlainText().length >= 1501 && label !== 'Activity' && name !== 'raw' && !isHiddenOpt && !noLimit) {
            editorState = EditorState.createWithContent(ContentState.createFromText(editorState?.getCurrentContent()?.getPlainText().slice(0, 1500)))
            setEditorState(editorState)
            // setEditorState(EditorState.moveFocusToEnd(editorState))
            EditorState.undo(editorState)
        } else if(!isMax && isHiddenOpt && !noLimit) {
            EditorState.undo(editorState)
        } else {
            setEditorState(editorState)
        }

        let newData = {
            target: {
                name: name,
                id: id,
                value: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
        }
        if ((topic_id && _id) || (topic_id === 0 || _id === 0)) {
            handleChange(newData, topic_id, _id)
        }
        else {
            if (eventData._id) {
                delete newData.target.id
            }
            newData['type'] = 'change';
            handleChange(newData)
        }
    };
    //----------------------------------------------------------------===========================================----------------------------------------------------------------------//
    const uploadImageCallBack = (file) => {
        return new Promise(
            (resolve, reject) => {
                const config = {
                    headers: { "content-type": "multipart/form-data" },
                    onUploadProgress: event => {
                        const percent = Math.floor((event.loaded / event.total) * 100);
                        if (percent === 100) {
                        }
                    }
                };
                const fileData = new FormData();
                fileData.append('file', file);
                const uploadFunction =  ["dl-program","pre-college","certificates"]?.includes(contextReducer?.cms_type) ? S3FileUpload : S3FileUploadPost;
                uploadFunction(fileData, config).then(res => {
                    if (res.data.status === 200) {
                        resolve({ data: { link: ["dl-program","pre-college","certificates"]?.includes(contextReducer?.cms_type) ? res.data.url : res.data.data.url } });
                    } else if (res.data.status === 103) {
                        handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
                    } else {
                        reject(res.data.message);
                        handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
                    }
                }).catch(err => {
                    reject(err.message);
                    handleOpenModal('ErrorPop', { header: "Error", body: err.message })
                });
            }
        );
    }

    const addActivityPost = () => {
        const newData = {
            course_id: course_id,
            discourse_post_id: post_id,
            raw: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        };

        postActivity(newData).then(res => {
            if (res.data.status === 200) {
                handleOpenModal('ErrorPop', { header: "Success", body: res.data.message })
            } else if (res.data.status === 103) {
                handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
            } else {
                handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
            }
        }).catch(err => {
            handleOpenModal('ErrorPop', { header: "Error", body: err.message })
        });
    }

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                 setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const handleFocus = (e) => {
        const data = { target: { name: name } };
        if(type){
            handleError && handleError(data,{id,type})
        }else{
            handleError && handleError(data);
        }
    }

    
    return (
        <>
            <div className="form_group">
                <div className={`${isLableRight ?"align_item_top" :"form_label d_flex flex_direction_column justify_content_between"} ${isHiddenOpt ? "":"pb_4"}`}>
                    <label htmlFor="">{label}</label>
                    {
                        uploadLabel && (
                            <>
                                <div className="fullWidth">
                                    <label htmlFor="">{uploadLabel} </label>
                                    <Upload ref={uploadList} accept={rest?.accept} customRequest={(e) => handleChange({ file: e, type: "file", name: "avatar", id: id })}  showUploadList={false} className="bio_file_upload file_upload mb_3">
                                        <div className="file_upload_button">
                                            {!uploadValue &&
                                                <span>
                                                    {
                                                        uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                                            uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 ?
                                                            <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} /> :
                                                            <img src={icon_plus_white} alt="" />
                                                    }
                                                </span>
                                            }
                                            {
                                                uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                                    uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 ?
                                                    <div className="sample_video_thumb">
                                                        <span className="uploaded_thumb_img">
                                                            <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} />
                                                        </span>
                                                    </div> :
                                                    uploadValue && (
                                                        <div className="sample_video_thumb">
                                                            <span className="uploaded_thumb_img  cursor_pointer">
                                                                <img src={uploadValue || staticImg} alt="Video thumb" className="img_fluid img_object_center radius_5" height="85" width="85" />
                                                            </span>
                                                        </div>
                                                    )
                                            }
                                        </div>
                                    </Upload>
                                </div>
                            </>
                        )
                    }
                </div>
                <div className="form_input activity_editor">
                    {/* <span><img src={icone_upload} alt='upload_file' /></span> */}
                    <Editor
                        ref={editorRef}
                        name={name}
                        editorState={editorState}
                        placeholder={placeholder}
                        wrapperClassName={`customEditor ${isHiddenOpt ? "hidden-opt":""}`}
                        editorClassName="customEditor_textarea"
                        toolbarClassName="customEditor_toolbar"
                        onEditorStateChange={onEditorStateChange}
                        handleBeforeInput={handleBeforeInput}
                        handlePastedText={() => paste}
                        onFocus={handleFocus}
                        toolbarCustomButtons={[<CustomOption />]}
                        toolbar={{
                            options: name === 'raw' ? ['inline', 'list', 'link', 'image', 'emoji'] :  (name === 'overview' || name === "answer"|| name === "Instructions") ? ['inline', 'image', 'link' , 'list', 'textAlign', 'emoji'] : ['inline', 'list', 'textAlign', 'emoji'],
                            inline: { inDropdown: true, options: ['bold', 'italic', 'underline'] },

                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: { options: ['link'] },
                            history: { inDropdown: true },
                            image: {
                                urlEnabled: false,
                                uploadEnabled: true,
                                alignmentEnabled: false,
                                uploadCallback: uploadImageCallBack,
                                previewImage: true,
                                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                alt: { present: false, mandatory: false },
                                defaultSize: {
                                    height: '100%',
                                    width: '100%',
                                },
                            },
                        }}
    
                    />
                    {label === 'Activity' && post_id && formData?.outline?.[+topic_id]?.sub_topic?.[+_id].type === 'group' && <span className="submit_activity" onClick={addActivityPost}><img src={true_icon} alt="" height="24" width="24" /></span>}
                    {label !== 'Activity' && name !== 'raw' && label !== 'Answer' && !isHiddenOpt && !noLimit && <p style={{ position: 'absolute', right: 0 }}>{editorState?.getCurrentContent()?.getPlainText().length}/1500</p>}
                    {errors && <div className="errMsg">{errors}</div>}
                </div>
                {
                    Modal && (
                        <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                            <Modal
                                error={error}
                                handleOpenModal={handleOpenModal}
                            />
                        </CustomModal>
                    )
                }
            </div>
        </>
    )
};

export default CustomTextEditor